import parse from 'html-react-parser';
import Image from 'next/image';
import Link from 'next/link';
import { FC } from 'react';

export interface ProductBannerProps {
  isNew?: boolean;
  href?: string;
  title: string;
  description: string;
  image: string;
  priority?: boolean;
}

export const ProductBanner: FC<ProductBannerProps> = ({
  image,
  isNew,
  href,
  description,
  title,
  priority,
}) => {
  return (
    <Link
      href={href ?? '#'}
      className="relative grid grid-cols-1 lg:grid-cols-2 overflow-hidden justify-center items-center my-12 gap-6"
    >
      <div className="flex flex-col justify-start items-start gap-4 md:gap-5 lg:gap-6 h-full">
        {isNew && (
          <span className="inline-flex py-2 px-3 bg-[#A9D0CD] text-[#282828]">
            Новинка
          </span>
        )}

        <p className="text-[28px] lg:text-5xl font-medium">{parse(title)}</p>
        <p className="text-[18px] lg:text-[28px] font-[400] mt-0 md:mt-[15px]">
          {parse(description)}
        </p>
      </div>
      <div
        className={'flex flex-col w-full h-full items-center justify-center'}
      >
        {image && (
          <Image
            className="px-3 md:px-12 lg:px-0"
            width={823}
            height={396}
            src={image}
            alt={title}
            loading="eager"
            priority={priority}
          />
        )}
      </div>
    </Link>
  );
};
